import React, { Component } from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
// Services and Actions
import { fetchGetVehicles, fetchFilterVehicles, fetchLogout } from 'alelo-logic/actions'
import { setLoading } from '../../modules/PageLoader/actions'
// Components
import { showModal } from '../../modules/ModalRoot/actions'
import { CONFIRM_UPDATE } from '../../../constants/ModalTypes'
import IdentifiersList from '../../modules/IdentifiersListForPartners'
import {
  Heading,
  Paragraph,
  Content,
  SearchBox,
  // LoadingContainer,
  Subheader,
  QRCodeContainer
  // LoadingText
} from './styles'
import SearchForm from 'app/modules/SearchForm'
import QRCodeReader from 'app/modules/QRCodeReader'
// import ManagementModal from 'app/modules/ManageInfoModal'
import ActivationForPartner from 'app/pages/ActivationForPartner'
// Assets
// import IconLoading from 'app/elements/Icon/ic-loading'

import { helmetTitle, identifiersTitle, identifiersDescription } from './data.json'
// import image from '../../../static/alterarSenha.png'
class DashboardIdentifiersForPartners extends Component {
  constructor(props) {
    super(props)
    this.state = {
      itemsSelected: [],
      searchText: '',
      identifiersList: [],
      listGrowNumber: 20,
      isLoadingMoreItems: false,
      modalIsOpen: false,
      vehicle: {},
      numberVeloeTag: '',
      nextAgain: false,
      QRCodeIsOpen: false
    }
  }

  handleSearchChange = ({ target }) => {
    this.setState({ searchText: target.value })
  }

  // Checkbox
  handleSelectItem = item => () => {
    const { itemsSelected } = this.state
    let newArray
    const hasItem =
      itemsSelected.findIndex(({ idIdentificador }) => item.idIdentificador === idIdentificador) !==
      -1
    if (hasItem) {
      newArray = itemsSelected.filter(
        ({ idIdentificador }) => item.idIdentificador !== idIdentificador
      )
      return this.setState({ itemsSelected: newArray })
    }
    newArray = [...itemsSelected, item]
    this.setState({ itemsSelected: newArray })
  }

  handleGetVehicle = (identifierNumber, next) => {
    const { identifiersList } = this.state
    this.props.dispatch(fetchFilterVehicles(identifierNumber)).then(resp => {
      if (!resp[0].veiculo) {
        this.setState({ numberVeloeTag: identifierNumber, nextAgain: next }, () =>
          this.toggleModal()
        )
      } else {
        if (
          identifiersList.filter(
            ({ codIdentificador }) => codIdentificador === resp[0].codIdentificador
          ).length < 1
        )
          this.setState({ identifiersList: [...identifiersList, resp[0]] })

        if (next) this.toggleQRCode(true)

        this.props.dispatch(
          showModal(CONFIRM_UPDATE, {
            modalTitle: `VeloeTag: ${resp[0].codIdentificador} já cadastrada.`,
            modalDescription: `Placa: ${resp[0].veiculo.placa}`
          })
        )
      }
    })
  }

  handleSetIdentifiers = identifiersList => {
    const indetifierItem = {
      situacao: 'ATIVO',
      codIdentificador: identifiersList.identifier,
      veiculo: { placa: identifiersList.plate }
    }
    this.setState({ identifiersList: [...this.state.identifiersList, indetifierItem] })
  }

  toggleModal = () => {
    this.setState({ modalIsOpen: !this.state.modalIsOpen })
  }

  toggleQRCode = status => this.setState({ QRCodeIsOpen: status })

  render() {
    const {
      searchText,
      itemsSelected,
      identifiersList,
      // isLoadingMoreItems,
      modalIsOpen,
      // vehicle,
      numberVeloeTag,
      nextAgain,
      QRCodeIsOpen
    } = this.state

    return (
      <section>
        <Helmet title={helmetTitle} />
        <Content>
          <Heading>{identifiersTitle}</Heading>
          <Paragraph>{identifiersDescription}</Paragraph>
          <Subheader>
            <QRCodeContainer>
              <QRCodeReader
                isOpen={QRCodeIsOpen}
                setIsOpen={this.toggleQRCode}
                onScan={identifierNumber => this.handleGetVehicle(identifierNumber, true)}
              />
            </QRCodeContainer>
            <SearchBox>
              <SearchForm
                value={searchText}
                onChange={this.handleSearchChange}
                onSearch={() => this.handleGetVehicle(searchText, false)}
                placeholder="Insira o nº da VeloeTag"
              />
            </SearchBox>
          </Subheader>
          <IdentifiersList
            handleCreateInf={this.handleModalCreateInfo}
            checkboxValues={itemsSelected}
            // handleLoadMoreItems={this.loadMoreItems}
            // handleSelectItem={this.handleSelectItem}
            // handleSelectAll={this.handleSelectAll}
            identifiers={identifiersList}
          />
          {modalIsOpen && (
            <ActivationForPartner
              numberVeloeTag={numberVeloeTag}
              toggleModal={this.toggleModal}
              setIdentifiers={this.handleSetIdentifiers}
              next={nextAgain}
              toggleQRCode={this.toggleQRCode}
              {...this.props}
            />
          )}
        </Content>
      </section>
    )
  }
}

export const mapStateToProps = ({ reducer }) => ({
  vehicles: reducer.dashboardVehicles,
  accountPlans: reducer.accountPlans
})

export const mapDispatchToProps = dispatch => ({
  fetchVehicles: (history, accountId) =>
    dispatch(fetchGetVehicles(accountId)).then(resp => {
      if (resp && (resp.status === 401 || resp.status === 403)) {
        dispatch(fetchLogout())
        history.push('/conta/login')
      }
      dispatch(setLoading(false))
    }),
  // fetchFilterVehicles: (history, identifierNumber) =>
  //   dispatch(fetchFilterVehicles(identifierNumber)).then(resp => {
  //     if (resp && (resp.status === 401 || resp.status === 403)) {
  //       dispatch(fetchLogout())
  //       history.push('/conta/login')
  //     }
  //     dispatch(setLoading(false))
  //   }),
  setLoading: isLoading => {
    dispatch(setLoading(isLoading))
  },
  dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(DashboardIdentifiersForPartners)



// WEBPACK FOOTER //
// ./src/app/pages/DashboardIdentifiersForPartners/index.js